<template>
  <div class="status-guide">
    <div class="status-list">
      <CCheckBox
        label="Student Number"
        :checked="aptFilterData.student_sis_id"
        name="student_sis_id"
        class="custom-checkbox"
        @change="updateFilters"
        :inline="true"
        :custom="true"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "DashboardTimeFilters",
  computed: {
    ...mapGetters({
      aptFilterData: "dashboardTable/aptFilterData"
    })
  },
  methods: {
    updateFilters(event) {
      this.$store.commit("dashboardTable/UPDATE_APT_FILTERS_DATA", {
        filter: event.target.name,
        value: event.target.checked
      })
    }
  }
}
</script>

<style></style>
